<template>
  <div v-if="events?.length && allEventsPath" class="sidebar-block">
    <div class="detail-layout-events">
      <div class="flex justify-between">
        <h2 class="title is-h5">
          {{ $texts('upcomingEvents', 'Upcoming events') }}
        </h2>
        <SpriteSymbol name="calendar" class="size-6" />
      </div>
      <div class="events-list">
        <NuxtLink
          v-for="event in events"
          :key="event.id"
          class="events-list-item"
          :to="`${allEventsPath}?eventId=${event.guidleId}`"
        >
          <div class="title is-size-6">
            {{ event.name }}
          </div>
          <ul class="info-list is-size-7">
            <li>{{ event.nextOccurrence?.formatted }}</li>
            <!-- <li v-if="event.otherDates"> -->
            <!--   {{ event.otherDates }} -->
            <!-- </li> -->
          </ul>
        </NuxtLink>
      </div>
      <div class="detail-layout-events-button">
        <NuxtLink :to="allEventsPath" class="link with-arrow">
          {{ $texts('showAllEvents', 'Show all events') }}
        </NuxtLink>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { notNullish } from '@vueuse/core'

const { $texts } = useEasyTexts()

const props = defineProps<{
  nid: string
}>()

const data = useInitData()
const language = useCurrentLanguage()

const allEventsPath = computed(() => data.value.pages.eventCalendar)

const { data: events } = await useAsyncGraphqlQuery(
  'loadDiscoverSwissEvents',
  { id: props.nid },
  {
    transform: function (data) {
      const entity = data.data.entityById
      if (
        entity &&
        'discoverSwissItem' in entity &&
        entity.discoverSwissItem?.eventsQuery?.items
      ) {
        return (entity.discoverSwissItem.eventsQuery.items || []).filter(
          notNullish,
        )
      }

      return []
    },
    deep: false,
    graphqlCaching: {
      client: true,
    },
    watch: [language],
  },
)
</script>

<style lang="postcss">
.detail-layout-events {
  @apply relative;
  > .icon {
    @apply absolute right-0 top-0 text-size-4-5 text-scheme-invert;
  }
}
.events-list-item {
  @apply block border-b border-solid border-border px-0 py-[0.75rem];
  .title {
    @apply mb-[0.25em];
  }
  &:hover {
    @apply bg-scheme-main-bis text-black;
  }
  .info-list {
    @apply text-scheme-invert-ter;
  }
}
.info-list {
  @apply flex leading-none;
  > li {
    &:not(:last-child) {
      &:after {
        content: ' - ';
        @apply mx-[0.5em] my-0 inline-block;
      }
    }
  }
}
.detail-layout-events-button {
  @apply mt-[1rem];
}
</style>
